import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Menu, X } from "lucide-react";

const Header = () => {
  const [isOpen, setIsOpen] = useState(false);

  const closeMenu = () => setIsOpen(false);

  return (
    <header className="fixed top-0 left-0 z-50 w-full">
      <nav className="border-b border-gray-100 bg-white/95 py-3 backdrop-blur-md dark:border-gray-800 dark:bg-gray-900/95">
        <div className="mx-auto flex max-w-screen-xl items-center justify-between px-4 lg:px-6">
          
          {/* Logo */}
          <Link
            to="/"
            className="flex items-center gap-2"
            onClick={closeMenu}
          >

            <span className="text-xl font-bold text-gray-900 dark:text-white">
              Zeed<span className="text-purple-600">Bio</span>
            </span>
          </Link>

          {/* Desktop Navigation */}
          <div className="hidden items-center gap-7 lg:flex">
            <a
              href="#features"
              className="text-sm font-medium text-gray-600 transition hover:text-purple-600 dark:text-gray-300 dark:hover:text-purple-400"
            >
              Features
            </a>

            <a
              href="#how-it-works"
              className="text-sm font-medium text-gray-600 transition hover:text-purple-600 dark:text-gray-300 dark:hover:text-purple-400"
            >
              How it works
            </a>

            <a
              href="#pricing"
              className="text-sm font-medium text-gray-600 transition hover:text-purple-600 dark:text-gray-300 dark:hover:text-purple-400"
            >
              Pricing
            </a>

            <a
              href="#faq"
              className="text-sm font-medium text-gray-600 transition hover:text-purple-600 dark:text-gray-300 dark:hover:text-purple-400"
            >
              FAQ
            </a>
          </div>

          {/* Desktop Actions */}
          <div className="hidden items-center gap-2 sm:flex">
            <Link
              to="/admin/login"
              className="rounded-lg px-4 py-2 text-sm font-medium text-gray-700 transition hover:bg-gray-100 dark:text-white dark:hover:bg-gray-800"
            >
              Log in
            </Link>

            <Link
              to="/register"
              className="rounded-lg bg-purple-700 px-5 py-2.5 text-sm font-medium text-white shadow-sm transition hover:bg-purple-800 focus:outline-none focus:ring-4 focus:ring-purple-300 dark:bg-purple-600 dark:hover:bg-purple-700"
            >
              Create your ZeedBio
            </Link>
          </div>

          {/* Mobile Menu Button */}
          <button
            type="button"
            onClick={() => setIsOpen(!isOpen)}
            className="inline-flex items-center rounded-lg p-2 text-gray-700 hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-purple-300 sm:hidden dark:text-white dark:hover:bg-gray-800"
            aria-label="Toggle menu"
          >
            {isOpen ? (
              <X className="h-6 w-6" />
            ) : (
              <Menu className="h-6 w-6" />
            )}
          </button>
        </div>

        {/* Mobile Menu */}
        {isOpen && (
          <div className="border-t border-gray-100 bg-white px-4 py-4 sm:hidden dark:border-gray-800 dark:bg-gray-900">
            <div className="flex flex-col gap-2">
              
              <a
                href="#features"
                onClick={closeMenu}
                className="rounded-lg px-4 py-3 text-sm font-medium text-gray-700 transition hover:bg-purple-50 hover:text-purple-600 dark:text-gray-300 dark:hover:bg-gray-800"
              >
                Features
              </a>

              <a
                href="#how-it-works"
                onClick={closeMenu}
                className="rounded-lg px-4 py-3 text-sm font-medium text-gray-700 transition hover:bg-purple-50 hover:text-purple-600 dark:text-gray-300 dark:hover:bg-gray-800"
              >
                How it works
              </a>

              <a
                href="#pricing"
                onClick={closeMenu}
                className="rounded-lg px-4 py-3 text-sm font-medium text-gray-700 transition hover:bg-purple-50 hover:text-purple-600 dark:text-gray-300 dark:hover:bg-gray-800"
              >
                Pricing
              </a>

              <a
                href="#faq"
                onClick={closeMenu}
                className="rounded-lg px-4 py-3 text-sm font-medium text-gray-700 transition hover:bg-purple-50 hover:text-purple-600 dark:text-gray-300 dark:hover:bg-gray-800"
              >
                FAQ
              </a>

              <div className="my-2 border-t border-gray-200 dark:border-gray-700" />

              <Link
                to="/admin/login"
                onClick={closeMenu}
                className="rounded-lg px-4 py-3 text-center text-sm font-medium text-gray-700 transition hover:bg-gray-100 dark:text-white dark:hover:bg-gray-800"
              >
                Log in
              </Link>

              <Link
                to="/register"
                onClick={closeMenu}
                className="rounded-lg bg-purple-700 px-5 py-3 text-center text-sm font-medium text-white transition hover:bg-purple-800"
              >
                Create your ZeedBio
              </Link>

            </div>
          </div>
        )}
      </nav>
    </header>
  );
};

export default Header;